import { useSubscribe } from "@/src/lib/actions";
import { useState } from "react";

export enum SortByCustomersOptions {
  "BOOKING_DATE" = "Booking date",
  "PAYMENT_STATUS" = "Payment status",
  "SUPPLIER" = "Supplier",
}

export enum SortByOperatorsOptions {
  "BOOKING_DATE" = "Booking date",
  "DUE_DATE" = "Due date",
  "NEW_BOOKINGS" = "New bookings",
  "PAYMENT_STATUS" = "Payment status",
  "SUPPLIER" = "Supplier",
}

export function usePageSize() {
  const [pageSize, setPageSize] = useState(10);

  useSubscribe<number>("payments-customers:page-size", setPageSize);

  return pageSize;
}

export function usePageSort() {
  const [customerSortBy, setCustomerSortBy] = useState<SortByCustomersOptions>(SortByCustomersOptions.BOOKING_DATE);
  const [operatorSortBy, setOperatorSortBy] = useState<SortByOperatorsOptions>(SortByOperatorsOptions.BOOKING_DATE);

  useSubscribe<SortByCustomersOptions>("payments-customers:sortBy", setCustomerSortBy);
  useSubscribe<SortByOperatorsOptions>("payments-operators:sortBy", setOperatorSortBy);

  return { customerSortBy, operatorSortBy };
}

export function useFilters() {
  const [customerId, setCustomerId] = useState<string | null>(null);
  const [operatorId, setOperatorId] = useState<string | null>(null);
  const [amountFrom, setAmountFrom] = useState<number | null>(null);
  const [amountTo, setAmountTo] = useState<number | null>(null);
  const [amountCurrency, setAmountCurrency] = useState<number | null>(null);
  const [bookingRef, setBookingRef] = useState<string | null>(null);
  const [operatorRef, setOperatorRef] = useState<string | null>(null);

  useSubscribe<string | null>("payments:filter-customer-id", setCustomerId);
  useSubscribe<string | null>("payments:filter-operator-id", setOperatorId);
  useSubscribe<number | null>("payments:filter-amount-from", setAmountFrom);
  useSubscribe<number | null>("payments:filter-amount-to", setAmountTo);
  useSubscribe<number | null>("payments:filter-amount-currency", setAmountCurrency);
  useSubscribe<string | null>("payments:filter-booking-ref", setBookingRef);
  useSubscribe<string | null>("payments:filter-operator-ref", setOperatorRef);

  return {
    customerId,
    operatorId,
    amountFrom,
    amountTo,
    amountCurrency,
    bookingRef,
    operatorRef,
  };
}

export function useSearch() {
  const [search, setSearch] = useState("");

  useSubscribe<string>("loc:search", setSearch);

  return search;
}
